import React from 'react';
import styles from './DocumentTenantBtn.module.scss';
import cn from 'classnames';
import { Icon, Tooltip } from 'antd';
import useClientDocuments from '../../../queries/useClientDocuments';
import { AllTenantDocumentsModal } from '../modals/AllTenantDocumentsModal/AllTenantDocumentsModal';
import useChangeModalVisible from '../../../../../hooks/useChangeModalVisible';

const DocumentTenantBtn = ({ clientId, className, ...props }) => {
  const { visible, showModal, hideModal } = useChangeModalVisible();

  const { data: clientDocuments, isFetching: isClientDocumentsFetching } =
    useClientDocuments(clientId, {
      staleTime: 60 * 5 * 1000,
    });

  const hasDocs = !!clientDocuments?.length;

  const handleOpenModal = () => {
    showModal();
  };

  return (
    <>
      <Tooltip title={hasDocs ? 'Документы' : 'Добавить документ'}>
        <div
          className={cn(styles.root, className)}
          {...props}
          onClick={handleOpenModal}
        >
          <Icon
            type={isClientDocumentsFetching ? 'loading' : 'paper-clip'}
            style={{ color: hasDocs ? '#0995ed' : '#888', fontSize: 20 }}
          />
        </div>
      </Tooltip>

      <AllTenantDocumentsModal
        clientId={clientId}
        visible={visible}
        onCancel={hideModal}
      />
    </>
  );
};

export default DocumentTenantBtn;
